import React from 'react';
import classnames from 'classnames';
import SubscribeButton from '../../../../Button/SubscribeButton';
import TierPricePerMonth from '../../../Helper/TierPricePerMonth';
import s from './PriceAndSubscribeButton.scss';
/** Price/month and subscribe button */ const PriceAndSubscribeButton = ({ tier, className })=>{
    var _tier_tier, _tier_tier1;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, ((_tier_tier = tier.tier) === null || _tier_tier === void 0 ? void 0 : _tier_tier.dollarPrice) && /*#__PURE__*/ React.createElement(TierPricePerMonth, {
        className: s['price'],
        price: (_tier_tier1 = tier.tier) === null || _tier_tier1 === void 0 ? void 0 : _tier_tier1.dollarPrice
    }), /*#__PURE__*/ React.createElement(SubscribeButton, {
        className: s['subscribe-button'],
        tier: tier,
        href: tier.url,
        size: "small"
    }));
};
PriceAndSubscribeButton.displayName = 'PriceAndSubscribeButton';
export default PriceAndSubscribeButton;
